import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { If,Then } from 'react-if';
import _ from 'lodash';

import StatePicker from '../../utility/state-picker';
import TpnCollection from '../../utility/tpn-collection';
import ProviderSpecialtyCollection from '../../utility/provider-specialty-collection';
import ApiCollection from '../../utility/api-collection';

class Form extends React.Component{ 
  render(){
    return(
      <Formik
        initialValues={{
          licenseNumber: '',
          npi: '',
          firstName: '',
          lastName: '',
          minAge: '',
          maxAge: '',
          username: ''
        }}
        onSubmit={(values, { setSubmitting }) => {
          this.props.applySearchFilter(values);
          setSubmitting(false);
        }}
        validationSchema={Yup.object().shape({
          licenseNumber: Yup.string()
        })}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            dirty,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            setFieldValue,
            submitForm
          } = props;
          return (
            <form onSubmit={handleSubmit}>
              <div className='filter'>
                <label htmlFor="providerId" style={{display: 'block'}}>
                  Provider ID 
                </label>
                <input
                  id="providerId"
                  placeholder="Provider ID"
                  type="text"
                  value={values.providerId}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                />
              </div>
              <div className='filter'>
                <label htmlFor="firstName" style={{display: 'block'}}>
                  First Name
                </label>
                <input
                  id="firstName"
                  placeholder="First Name"
                  type="text"
                  value={values.firstName}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                  onBlur={handleBlur}
                  className={
                    errors.firstName && touched.firstName? 'text-input error' : 'text-input'
                  }
                />
              </div>
              <div className='filter'>
                <label htmlFor="lastName" style={{display: 'block'}}>
                  Last Name
                </label>
                <input
                  id="lastName"
                  placeholder="Last Name"
                  type="text"
                  value={values.lastName}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                  onBlur={handleBlur}
                  className={
                    errors.lastName && touched.lastName? 'text-input error' : 'text-input'
                  }
                />
              </div>
              <div className='filter'>
                <label htmlFor="username" style={{display: 'block'}}>
                  Username
                </label>
                <input
                  id="username"
                  placeholder="Username"
                  type="text"
                  value={values.username}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                  onBlur={handleBlur}
                  className={
                    errors.username && touched.username ? 'text-input error' : 'text-input'
                  }
                />
              </div>
              <div className='filter'>
                <label htmlFor="npi" style={{display: 'block'}}>
                  NPI
                </label>
                <input
                  id="npi"
                  placeholder="NI"
                  type="text"
                  value={values.npi}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                  onBlur={handleBlur}
                  className={
                    errors.npi && touched.npi? 'text-input error' : 'text-input'
                  }
                />
              </div>
              <div className='filter'>
                <label htmlFor="licenseStates" style={{display: 'block'}}>
                  License
                </label>
                <StatePicker
                  multiple={true}
                  style={{ width: 190 }}
                  onSelect={ (ev) => {
                    setFieldValue('licenseStates', 
                      [].slice
                      .call(ev.target.selectedOptions)
                      .map(option => option.value)
                    )
                    setTimeout( () => handleSubmit(ev) , 0 );
                  } }
                />
              </div>
              <div className='filter'>
                <label htmlFor="minAge" style={{display: 'block'}}>
                  Min Age 
                </label>
                <input
                  id="minAge"
                  placeholder="Min Age"
                  type="number"
                  value={values.minAge}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                  onBlur={handleBlur}
                  className={
                    errors.minAge && touched.minAge ? 'text-input error' : 'text-input'
                  }
                />
              </div>
              <div className='filter'>
                <label htmlFor="maxAge" style={{display: 'block'}}>
                  Max Age 
                </label>
                <input
                  id="maxAge"
                  placeholder="Max Age"
                  type="number"
                  value={values.maxAge}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                  onBlur={handleBlur}
                  className={
                    errors.maxAge && touched.maxAge ? 'text-input error' : 'text-input'
                  }
                />
              </div>
              <div className='filter'>
                <label htmlFor="providerIsActive" style={{display: 'block'}}>
                  Status
                </label>
                <select
                  id="providerIsActive"
                  placeholder="Max "
                  type="text"
                  value={values.providerIsActive}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                  onBlur={handleBlur}
                  className={
                    errors.maxAge && touched.maxAge ? 'text-input error' : 'text-input'
                  }
                  style={{width: 190}}
                >
                  <option value=""></option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>
              <div className='filter'>
                <label htmlFor="clockIn" style={{display: 'block'}}>
                  Clocked In
                </label>
                <select
                  id="clockIn"
                  type="text"
                  value={values.clockIn}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                  onBlur={handleBlur}
                  style={{width: 190}}
                >
                  <option value=""></option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
              <div className='filter'>
                <label htmlFor="medicaidNumbers" style={{display: 'block'}}>
                  Medicaid Number
                </label>
                <input
                  id="medicaidNumbers"
                  placeholder=""
                  type="text"
                  value={values.medicaidNumbers}
                  onChange={(ev) => {
                    handleChange(ev);
                    setTimeout( () => handleSubmit(ev) , 0 );
                  }}
                  onBlur={handleBlur}
                  className={
                    errors.medicaidId && touched.medicaidId? 'text-input error' : 'text-input'
                  }
                />
              </div>
              <div className='filter'>
                <label htmlFor="tpnNames" style={{display: 'block'}}>
                  TPN
                </label>
                <TpnCollection>
                  { (tpns) => (
                    <select
                      onChange={(ev) => {
                        handleChange(ev);
                        setTimeout( () => handleSubmit(ev) , 0 );
                      }}
                      name='tpnNames'
                      style={{width: 190}}
                    
                    >
                      <option value=''></option>
                      { tpns.map ( tpn => <option value={tpn.name} key={tpn.ref_tpn_id}>{tpn.name}</option> ) }
                    </select>
                  )}
                </TpnCollection>
              </div>
              <ApiCollection endpoint='/v4/ref_provider_roles/classifications_and_specialties'>
                { (specialities) => {
                  return (
                    <div className='filter'>
                      <label htmlFor="primaryRoleName" style={{display: 'block'}}>
                        Provider Role
                      </label>
                      <select
                        onChange={(ev) => {
                          setFieldValue('primaryRoleName', ev.target.value);
                          setFieldValue('specialtyNames', '');
                          setTimeout( () => handleSubmit(ev) , 0 );
                        }}
                        name='primaryRoleName'
                        id='primaryRoleName'
                        style={{width: 190}}
                      >
                        <option value=''></option>
                        { Object.keys(specialities).map ( specialty => (
                          <option
                            value={specialty}
                            key={specialty}
                          >
                            {specialty}
                          </option>
                        ))}
                      </select>
                    </div>
                  )
                }}
              </ApiCollection>
              <If condition={Boolean(values.primaryRoleName)}>
                <Then>{() => {
                  return (
                    <ApiCollection endpoint='/v4/ref_provider_roles/classifications_and_specialties'>
                      { (specialities) => {
                        const uniqSpecialties = _.sortBy(_.uniqBy(
                          _.flatten(Object.values(specialities[values.primaryRoleName])),
                         'specialty_name'
                        ), (o) => o.specialty_name);
                        return (
                          <div className='filter'>
                            <label htmlFor="specialtyNames" style={{display: 'block'}}>
                              Specialty Name
                            </label>
                            <select
                              onChange={(ev) => {
                                handleChange(ev);
                                setTimeout( () => handleSubmit(ev) , 0 );
                              }}
                              name='specialtyNames'
                              id='specialtyNames'
                              style={{width: 190}}
                            >
                              <option value=''></option>
                              { uniqSpecialties.sort().map ( specialty => {
                                return (
                                  <option
                                    value={specialty.specialty_name}
                                    key={specialty.specialty_code}
                                  >
                                    {specialty.specialty_name}
                                  </option>
                                )
                             })}
                            </select>
                          </div>
                        )
                      }}
                    </ApiCollection>
                  ) 
                }}</Then> 
              </If>
            </form>
          );
        }}
      </Formik>

    );
  }
}

export default Form;
